/**
 *  Adiciione um id com o valor 'ocultarExibirFiltro' na div que sera clicada.
 *  Adicione uma class com o valor 'containerFiltro' na div que sera ocultada.
 */
(function () {

    const divFiltro = document.getElementById('ocultarExibirFiltro');
    if(divFiltro) {
        const containerFiltro = document.getElementById('containerFiltro');
        divFiltro.addEventListener('click', function () {
            containerFiltro.classList.toggle('hide');
        });

        document.addEventListener('DOMContentLoaded', () => {
            const dados = $('#containerFiltro')
            .find('input[name!="_token"], select')
            .filter(function () {
                return $.trim(this.value).length > 0
            })
            .serializeArray();

            if(dados.length > 0) {
                containerFiltro.classList.remove('hide');
            }
        });
    }
})();
